import { render, staticRenderFns } from "./PageInjuriesPreventExercising.vue?vue&type=template&id=4f4eb5ed&scoped=true"
import script from "./PageInjuriesPreventExercising.vue?vue&type=script&lang=js"
export * from "./PageInjuriesPreventExercising.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4eb5ed",
  null
  
)

export default component.exports